import type { XmlAttribute } from '@capture/shared';

interface Props {
  attr: XmlAttribute;
  availableFields: string[];
  onUpdate: (next: XmlAttribute) => void;
  onDelete: () => void;
}

export function AttributeRow({ attr, availableFields, onUpdate, onDelete }: Props) {
  function handleNameChange(name: string) {
    onUpdate({ ...attr, name });
  }

  function handleSourceChange(source: 'field' | 'literal') {
    if (source === attr.source) return;
    if (source === 'field') {
      onUpdate({ name: attr.name, source: 'field', sourceField: '' });
    } else {
      onUpdate({ name: attr.name, source: 'literal', literal: '' });
    }
  }

  function handleValueChange(value: string) {
    if (attr.source === 'field') {
      onUpdate({ ...attr, sourceField: value });
    } else {
      onUpdate({ ...attr, literal: value });
    }
  }

  const valueLabel = attr.source === 'field' ? 'Field' : 'Value';

  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
      <input
        type="text"
        aria-label="Attribute name"
        value={attr.name}
        onChange={(e) => handleNameChange(e.target.value)}
        placeholder="name"
        style={{ flex: '0 0 140px' }}
      />
      <select
        aria-label="Source"
        value={attr.source}
        onChange={(e) => handleSourceChange(e.target.value as 'field' | 'literal')}
        style={{ flex: '0 0 100px' }}
      >
        <option value="literal">literal</option>
        <option value="field">field</option>
      </select>
      {attr.source === 'field' ? (
        availableFields.length === 0 ? (
          <input
            type="text"
            aria-label={valueLabel}
            value={attr.sourceField}
            onChange={(e) => handleValueChange(e.target.value)}
            placeholder="field name"
            style={{ flex: 1 }}
          />
        ) : (
          <select
            aria-label={valueLabel}
            value={attr.sourceField}
            onChange={(e) => handleValueChange(e.target.value)}
            style={{ flex: 1 }}
          >
            <option value="">— pick a field —</option>
            {availableFields.map((f) => (
              <option key={f} value={f}>{f}</option>
            ))}
          </select>
        )
      ) : (
        <input
          type="text"
          aria-label={valueLabel}
          value={attr.literal}
          onChange={(e) => handleValueChange(e.target.value)}
          placeholder="value"
          style={{ flex: 1 }}
        />
      )}
      <button
        type="button"
        onClick={onDelete}
        aria-label="Delete attribute"
        title="Delete attribute"
        style={{ flex: '0 0 auto' }}
      >
        ×
      </button>
    </div>
  );
}
